import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, inject} from '@angular/core';
import {MatChipEditedEvent, MatChipInputEvent, MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { PipesModule } from '../../pipes/pipes.module';

@Component({
  selector: 'app-mat-chips',
  standalone: true,
  imports: [MatFormFieldModule, MatChipsModule, MatIconModule, PipesModule],
  templateUrl: './mat-chips.component.html',
  styleUrl: './mat-chips.component.scss'
})
export class MatChipsComponent implements OnInit, OnChanges {
	addOnBlur = true;
	readonly separatorKeysCodes = [ENTER, COMMA] as const;
	announcer = inject(LiveAnnouncer);

	@Input() content: any[] = [];
	@Input() label: string = '';
	@Input() placeholder: string = '';

	@Input() preselectedKeywords: any[] = [];


	@Output() chips = new EventEmitter<any[]>();

	ngOnInit(): void {
		this.content = this.preselectedKeywords.map(keyword => ({ name: keyword }));
	}

	updateContentFromKeywords(): void {
		if (this.preselectedKeywords) {
		  this.content = this.preselectedKeywords.map(keyword => ({ name: keyword }));
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['preselectedKeywords']) {
		  this.updateContentFromKeywords();
		}
	}

	add(event: MatChipInputEvent): void {
	  const value = (event.value || '').trim();
	  if (value) {
		this.content.push({name: value});
	  }
	  event.chipInput!.clear();
	  this.chips.emit(this.content)
	}

	remove(content: any): void {
	  const index = this.content.indexOf(content);
	  if (index >= 0) {
		this.content.splice(index, 1);
		this.announcer.announce(`Removed ${content}`);
	  }
	  this.chips.emit(this.content)
	}

	edit(content: any, event: MatChipEditedEvent) {
	  const value = event.value.trim();
	  if (!value) {
		this.remove(content);
		return;
	  }
	  const index = this.content.indexOf(content);
	  if (index >= 0) {
		this.content[index].name = value;
	  }
	  this.chips.emit(this.content)
	}
  }
